import { useSearchParams, useLocation } from "react-router-dom-v5-compat";
import { useApi } from "./useApi";
import { useRules } from "../context";
import { useUrlState } from "./useUrlState";

export const useSearch = (options: $TSFixMe) => {
  const api = useApi();
  const rules = useRules();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();

  const [searchTerm, setSearchTerm] = useUrlState(
    "search",
    searchParams,
    setSearchParams,
  );
  const [filterValue, setFilterValue] = useUrlState(
    "filter",
    searchParams,
    setSearchParams,
  );
  const [optionValue, setOptionValue] = useUrlState(
    "option",
    searchParams,
    setSearchParams,
  );
  const [follow] = useUrlState("follow", searchParams, setSearchParams);

  const allowedFilters = rules.application().get("searchScope");
  const filters = (
    searchParams.get("filter") !== null ? filterValue : allowedFilters.join(",")
  )
    .split(",")
    .filter((f: $TSFixMe) => allowedFilters.includes(f));

  const allowedOptions = ["specifications", "nodes"];
  const searchOptions = (
    (searchParams.get("option") !== null
      ? optionValue
      : allowedOptions.join(",")) as $TSFixMe
  )
    .split(",")
    .filter((f: $TSFixMe) => allowedOptions.includes(f));

  const match = /\/nodes\/(\d+)/.exec(location.pathname);
  const nodeId = match ? match[1] : undefined;

  const parameters = {
    q: (searchTerm as $TSFixMe).trim(),
    scope: filters?.sort().join(","),
    per_page: 100,
    ...(nodeId && { node_id: nodeId }),
    ...(searchOptions.length && { include: searchOptions.join(",") }),
  };
  const {
    data,
    fetchNextPage,
    isFetchingNextPage,
    isFetching,
    hasNextPage,
    isInitialLoading,
  } = api.get.useInfiniteQuery(
    "/search",
    {
      ...parameters,
    },
    {
      enabled: !!parameters.q,
      select: (d: $TSFixMe) => ({
        results: d?.pages
          ?.map((page: $TSFixMe) =>
            page.results.map((result: $TSFixMe) => ({
              ...result,
              pictureUrl: result.picture_url,
            })),
          )
          .flat(),

        pagination: d?.pages[d.pages.length - 1].pagination,
      }),
      refetchOnWindowFocus: false,
      ...options,
    },
  );

  const results = (data as $TSFixMe)?.results;
  const totalCount = (data as $TSFixMe)?.pagination?.total_count;
  const isSearching = isInitialLoading || isFetching || isFetchingNextPage;
  const followFirstResult = follow === "true";

  return {
    results,
    totalCount,
    isSearching,
    isInitialSearching: isInitialLoading,
    hasNextPage,
    filters,
    options: searchOptions,
    searchTerm,
    fetchNextPage,
    isFetchingNextPage,
    setSearchTerm,
    setFilterValue,
    setOptionValue,
    followFirstResult,
  };
};
